// import React from "react";
// import { Pagination } from "react-bootstrap";
// import "../App.css";

// export default function CustomPagination({
//   currentPage = 1,
//   totalPages = 1,
//   onPageChange,
//   className = "",
//   siblingCount = 1,
//   ...rest
// }) {
//   if (totalPages <= 1) return null;

//   const pages = [];
//   const start = Math.max(2, currentPage - siblingCount);
//   const end = Math.min(totalPages - 1, currentPage + siblingCount);

//   pages.push(1);
//   if (start > 2) pages.push("start-ellipsis");
//   for (let i = start; i <= end; i++) pages.push(i);
//   if (end < totalPages - 1) pages.push("end-ellipsis");
//   if (totalPages > 1) pages.push(totalPages);

//   return (
//     <Pagination className={`custom-pagination ${className}`} {...rest}>
//       <Pagination.Prev
//         disabled={currentPage === 1}
//         onClick={() => onPageChange(currentPage - 1)}
//       />

//       {pages.map((p, idx) =>
//         p === "start-ellipsis" || p === "end-ellipsis" ? (
//           <Pagination.Ellipsis key={`${p}-${idx}`} disabled />
//         ) : (
//           <Pagination.Item
//             key={p}
//             active={p === currentPage}
//             onClick={() => onPageChange(p)}
//           >
//             {p}
//           </Pagination.Item>
//         )
//       )}

//       <Pagination.Next
//         disabled={currentPage === totalPages}
//         onClick={() => onPageChange(currentPage + 1)}
//       />
//     </Pagination>
//   );
// }

import React from "react";
import { Pagination } from "react-bootstrap";
import "../App.css";

export default function CustomPagination({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  className = "",
  pageClassName = "rr-page",
  activeClassName = "active",
  ellipsisClassName = "rr-page",
  siblingCount = 1,
  ...rest
}) {
  if (!totalPages || totalPages <= 1) return null;

  const pages = [];
  const start = Math.max(2, currentPage - siblingCount);
  const end = Math.min(totalPages - 1, currentPage + siblingCount);

  pages.push(1);
  if (start > 2) pages.push("start-ellipsis");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < totalPages - 1) pages.push("end-ellipsis");
  if (totalPages > 1) pages.push(totalPages);

  return (
    <Pagination className={`custom-pagination ${className}`} {...rest}>
      <Pagination.Prev
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
         className="rr-page-arrow"
      />

      {pages.map((p, idx) =>
        p === "start-ellipsis" || p === "end-ellipsis" ? (
          <Pagination.Ellipsis
            key={`${p}-${idx}`}
            disabled
            className={ellipsisClassName}
          />
        ) : (
          <Pagination.Item
            key={p}
            active={p === currentPage}
            onClick={() => onPageChange(p)}
            className={`${pageClassName} ${p === currentPage ? activeClassName : ""}`}
          >
            {p}
          </Pagination.Item>
        )
      )}

      <Pagination.Next
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="rr-page-arrow"
      />
    </Pagination>
  );
}